import { message } from 'antd'
import { useEffect, useReducer } from 'react'

import { history } from '../../redux/store'
import {
  DEL_INCREMENTASSESS,
  GET_GOODS_LIST,
  GoodsListParam,
  UPDATE_INCREMENTASSESS,
} from '../../api/MaterialApi'
import {
  ImportModalType,
  initialState,
  reducer,
  setDataSourceAction,
  setImportModalOptionAction,
  setIsTableLoading,
  setLoadingStateAction,
  setPaginationOptionAction,
  setSearchParamAction,
  setSelectedRowKeysAction,
  setSelectedRowsAction,
} from './reducer'
import { CustomerConfirm } from '../../components/ModalUser'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { SUPROUTE } from '../../route'
import { useCloseTab } from '../../tools/utilHooks'
import { useUserInfoLimit } from '@/hooks/limit'

export const handleJumpAddInvoice = (orderIds: string[]) => {
  history.push({
    pathname: '/srm/addinvoice',
    state: {
      orderIds,
    },
  })
}

export function useSetupHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { onCurrentPageClose } = useCloseTab()
  const {
    paginationOption,
    selectedRows,
    importModalOption,
    selectedRowKeys,
    loadingState,
    searchParam,
  } = state

  const { limitSrmProductType } = useUserInfoLimit()
  async function handlePaginationChange(page: number, pageSize?: number) {
    await getPageData({
      pageNo: page,
      pageSize: pageSize ? pageSize : paginationOption.pagesize,
      ...searchParam,
    })
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
    dispatch(setSelectedRowKeysAction(selectedRowKeys))
  }

  async function getPageData(params: GoodsListParam) {
    const {
      pageNo = paginationOption.current,
      pageSize = paginationOption.pagesize,
    } = params
    dispatch(setIsTableLoading(true))
    const res = await GET_GOODS_LIST({
      ...params,
      pageSize,
      srmProductType: limitSrmProductType(params.srmProductType),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataSourceAction(res.data.content))
      dispatch(
        setPaginationOptionAction({
          pagesize: pageSize,
          current: pageNo,
          total: res.data.totalCount,
        }),
      )
    }
    dispatch(setIsTableLoading(false))
  }
  const handleSearchClick = (value: any) => {
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...value,
    })
    dispatch(setSearchParamAction(value))
  }
  const handleOperationMenuClick = (menuItem: any) => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选数据，再操作！')
      return
    }

    switch (menuItem.key as ImportModalType) {
      case '导入上架项目':
        // 检查勾选数据中的 productType 是否一致
        if (selectedRows && selectedRows.length > 0) {
          const productTypes = selectedRows.map((row: any) => row.productType)
          const uniqueProductTypes = Array.from(new Set(productTypes))
          if (uniqueProductTypes.length > 1) {
            message.error('勾选数据中的物料类型不一致，请重新选择！')
            return
          }
        }
        dispatch(
          setImportModalOptionAction({
            title: '导入上架项目',
            open: true,
          }),
        )

        break
      case '导入图片':
        dispatch(
          setImportModalOptionAction({
            title: '导入图片',
            open: true,
          }),
        )
        break
      case '导入拓展属性':
        dispatch(
          setImportModalOptionAction({
            title: '导入拓展属性',
            open: true,
          }),
        )
        break
      case '导入资质图片':
        dispatch(
          setImportModalOptionAction({
            title: '导入资质图片',
            open: true,
          }),
        )
        break
    }
  }
  async function handleTableRefresh() {
    await getPageData({
      pageNo: 1,
      pageSize: initialState.paginationOption.pagesize,
    })
  }
  function cancelImportModal() {
    dispatch(
      setImportModalOptionAction({
        ...importModalOption,
        open: false,
      }),
    )
  }

  // 删除
  const handleDelClick = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选数据，再操作！')
      return false
    }
    CustomerConfirm({
      title: '提示',
      content: '确定删除?',
      onOk: async () => {
        message.loading('删除中', 0)
        const res = await DEL_INCREMENTASSESS({
          productIds: selectedRowKeys.join(','),
        })
        if (isResponseCodeSuccess(res.code)) {
          message.success('删除成功')
          handleTableRefresh()
        }
      },
    })
  }
  async function handleAuditSubmit() {
    if (selectedRows.length < 1) {
      message.warning('请先勾选数据，再操作！')
      return false
    }
    CustomerConfirm({
      title: '提示',
      content: '确定提交?',
      onOk: async () => {
        dispatch(
          setLoadingStateAction({
            ...loadingState,
            isAuditSubmitButtonLoading: true,
          }),
        )
        const res = await UPDATE_INCREMENTASSESS({
          paramData: selectedRows.map((item) => ({
            id: item.id,
            mainPicture: item.mainPicture,
            detailsPicture: item.detailsPicture,
            extendedAttribute: item.extendedAttribute,
            tempCode: item.code,
          })),
          supplierId: getSupplierId(),
        })
        if (isResponseCodeSuccess(res.code)) {
          onCurrentPageClose(
            () =>
              history.replace({
                pathname: `${SUPROUTE}/submitResult`,
                state: {
                  data: selectedRows,
                },
              }),
            false,
          )
        } else {
          dispatch(
            setLoadingStateAction({
              ...loadingState,
              isAuditSubmitButtonLoading: false,
            }),
          )
        }
      },
    })
  }
  const handleImportSuccess = () => {
    cancelImportModal()
    // handleTableRefresh()
  }
  useEffect(() => {
    handleTableRefresh()
    // eslint-disable-next-line
  }, [])

  // 跳转详情
  const onJump = (info: any) => {
    history.replace({
      pathname: `${SUPROUTE}/toSubmitGoodsEdit`,
      state: {
        productId: info.id,
        BtnState: ['ToSubmitEdit'],
        auditSource: 'SRM_SECOND_ADD', // 审核来源：SCP新增物料（待提交物料）
      },
    })
  }

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleJumpAddInvoice,
    handleTableRefresh,
    handleOperationMenuClick,
    cancelImportModal,
    handleDelClick,
    handleAuditSubmit,
    handleImportSuccess,
    onJump,
  }
}
import { message } from 'antd'
import { useEffect, useReducer } from 'react'

import { history } from '../../redux/store'
import {
  DEL_INCREMENTASSESS,
  GET_GOODS_LIST,
  GoodsListParam,
  UPDATE_INCREMENTASSESS,
} from '../../api/MaterialApi'
import {
  ImportModalType,
  initialState,
  reducer,
  setDataSourceAction,
  setImportModalOptionAction,
  setIsTableLoading,
  setLoadingStateAction,
  setPaginationOptionAction,
  setSearchParamAction,
  setSelectedRowKeysAction,
  setSelectedRowsAction,
} from './reducer'
import { CustomerConfirm } from '../../components/ModalUser'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { SUPROUTE } from '../../route'
import { useCloseTab } from '../../tools/utilHooks'
import { useUserInfoLimit } from '@/hooks/limit'

export const handleJumpAddInvoice = (orderIds: string[]) => {
  history.push({
    pathname: '/srm/addinvoice',
    state: {
      orderIds,
    },
  })
}

export function useSetupHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { onCurrentPageClose } = useCloseTab()
  const {
    paginationOption,
    selectedRows,
    importModalOption,
    selectedRowKeys,
    loadingState,
    searchParam,
  } = state

  const { limitSrmProductType } = useUserInfoLimit()
  async function handlePaginationChange(page: number, pageSize?: number) {
    await getPageData({
      pageNo: page,
      pageSize: pageSize ? pageSize : paginationOption.pagesize,
      ...searchParam,
    })
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
    dispatch(setSelectedRowKeysAction(selectedRowKeys))
  }

  async function getPageData(params: GoodsListParam) {
    const {
      pageNo = paginationOption.current,
      pageSize = paginationOption.pagesize,
    } = params
    dispatch(setIsTableLoading(true))
    const res = await GET_GOODS_LIST({
      ...params,
      pageSize,
      srmProductType: limitSrmProductType(params.srmProductType),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataSourceAction(res.data.content))
      dispatch(
        setPaginationOptionAction({
          pagesize: pageSize,
          current: pageNo,
          total: res.data.totalCount,
        }),
      )
    }
    dispatch(setIsTableLoading(false))
  }
  const handleSearchClick = (value: any) => {
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...value,
    })
    dispatch(setSearchParamAction(value))
  }
  const handleOperationMenuClick = (menuItem: any) => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选数据，再操作！')
      return
    }

    switch (menuItem.key as ImportModalType) {
      case '导入上架项目':
        // 检查勾选数据中的 productType 是否一致
        if (selectedRows && selectedRows.length > 0) {
          const productTypes = selectedRows.map((row: any) => row.productType)
          const uniqueProductTypes = Array.from(new Set(productTypes))
          if (uniqueProductTypes.length > 1) {
            message.error('勾选数据中的物料类型不一致，请重新选择！')
            return
          }
        }
        dispatch(
          setImportModalOptionAction({
            title: '导入上架项目',
            open: true,
          }),
        )

        break
      case '导入图片':
        dispatch(
          setImportModalOptionAction({
            title: '导入图片',
            open: true,
          }),
        )
        break
      case '导入拓展属性':
        dispatch(
          setImportModalOptionAction({
            title: '导入拓展属性',
            open: true,
          }),
        )
        break
      case '导入资质图片':
        dispatch(
          setImportModalOptionAction({
            title: '导入资质图片',
            open: true,
          }),
        )
        break
    }
  }
  async function handleTableRefresh() {
    await getPageData({
      pageNo: 1,
      pageSize: initialState.paginationOption.pagesize,
    })
  }
  function cancelImportModal() {
    dispatch(
      setImportModalOptionAction({
        ...importModalOption,
        open: false,
      }),
    )
  }

  // 删除
  const handleDelClick = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选数据，再操作！')
      return false
    }
    CustomerConfirm({
      title: '提示',
      content: '确定删除?',
      onOk: async () => {
        message.loading('删除中', 0)
        const res = await DEL_INCREMENTASSESS({
          productIds: selectedRowKeys.join(','),
        })
        if (isResponseCodeSuccess(res.code)) {
          message.success('删除成功')
          handleTableRefresh()
        }
      },
    })
  }
  async function handleAuditSubmit() {
    if (selectedRows.length < 1) {
      message.warning('请先勾选数据，再操作！')
      return false
    }
    CustomerConfirm({
      title: '提示',
      content: '确定提交?',
      onOk: async () => {
        dispatch(
          setLoadingStateAction({
            ...loadingState,
            isAuditSubmitButtonLoading: true,
          }),
        )
        const res = await UPDATE_INCREMENTASSESS({
          paramData: selectedRows.map((item) => ({
            id: item.id,
            mainPicture: item.mainPicture,
            detailsPicture: item.detailsPicture,
            extendedAttribute: item.extendedAttribute,
            tempCode: item.code,
          })),
          supplierId: getSupplierId(),
        })
        if (isResponseCodeSuccess(res.code)) {
          onCurrentPageClose(
            () =>
              history.replace({
                pathname: `${SUPROUTE}/submitResult`,
                state: {
                  data: selectedRows,
                },
              }),
            false,
          )
        } else {
          dispatch(
            setLoadingStateAction({
              ...loadingState,
              isAuditSubmitButtonLoading: false,
            }),
          )
        }
      },
    })
  }
  const handleImportSuccess = () => {
    cancelImportModal()
    // handleTableRefresh()
  }
  useEffect(() => {
    handleTableRefresh()
    // eslint-disable-next-line
  }, [])

  // 跳转详情
  const onJump = (info: any) => {
    history.replace({
      pathname: `${SUPROUTE}/toSubmitGoodsEdit`,
      state: {
        productId: info.id,
        BtnState: ['ToSubmitEdit'],
        auditSource: 'SRM_SECOND_ADD', // 审核来源：SCP新增物料（待提交物料）
      },
    })
  }

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleJumpAddInvoice,
    handleTableRefresh,
    handleOperationMenuClick,
    cancelImportModal,
    handleDelClick,
    handleAuditSubmit,
    handleImportSuccess,
    onJump,
  }
}
